import { useState } from "react";
import { ArrowRight, Check } from "lucide-react";

export function NewsletterStrip() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) { setError("Please enter a valid email."); return; }
    setSubmitting(true);
    try {
      const res  = await fetch("/api/subscribe", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: trimmed }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.ok === false) { setError(data.error || "Could not subscribe. Please try again."); setSubmitting(false); return; }
      setSubmitted(true); setEmail("");
    } catch (_) { setError("Network error. Please try again."); }
    finally { setSubmitting(false); }
  }

  return (
    <div data-testid="newsletter-strip" className="flex flex-col sm:flex-row sm:items-start gap-6 sm:gap-8 px-7 py-7" style={{ background: "var(--blog-bg-secondary)", borderBottom: "0.5px solid var(--blog-border-tertiary)" }}>
      <div className="flex-1">
        <div className="uppercase mb-[6px]" style={{ fontSize: 9, letterSpacing: "0.14em", color: "var(--blog-accent-teal)" }}>Newsletter</div>
        <div className="font-display font-medium" style={{ fontSize: 19, lineHeight: 1.25, color: "var(--blog-text-primary)" }}>Worth reading. In your inbox.</div>
        <div className="mt-1" style={{ fontSize: 12, color: "var(--blog-text-tertiary)" }}>I write when I have something real to say. You'll hear from me then.</div>
      </div>
      <div className="shrink-0 flex flex-col gap-2">
        {submitted ? (
          <div data-testid="newsletter-success" className="inline-flex items-center gap-2 rounded-md px-4 py-[10px]" style={{ fontSize: 12, background: "var(--blog-badge-open-bg)", color: "var(--blog-badge-open-color)", border: "0.5px solid var(--blog-badge-open-border)" }}>
            <Check className="w-4 h-4" /> You're in. Talk soon.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2" data-testid="newsletter-form">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" autoComplete="email" name="email" id="newsletter-email" data-testid="newsletter-email-input" className="rounded-md outline-none"
              style={{ fontSize: 12, padding: "10px 14px", width: 220, maxWidth: "100%", border: "0.5px solid var(--blog-border-primary)", background: "var(--blog-bg-primary)", color: "var(--blog-text-primary)" }} />
            <button type="submit" disabled={submitting} data-testid="newsletter-subscribe-button" className="inline-flex items-center justify-center gap-2 rounded-md"
              style={{ fontSize: 11, fontWeight: 500, letterSpacing: "0.04em", padding: "10px 18px", background: "var(--blog-text-primary)", color: "var(--blog-bg-primary)", border: "none", cursor: submitting ? "wait" : "pointer", opacity: submitting ? 0.6 : 1, whiteSpace: "nowrap" }}>
              {submitting ? "Subscribing..." : "Subscribe"} <ArrowRight className="w-3 h-3" />
            </button>
          </form>
        )}
        {error && !submitted && (
          <div className="font-mono" style={{ fontSize: 10, letterSpacing: "0.04em", color: "#b91c1c", paddingTop: 2 }}>{error}</div>
        )}
      </div>
    </div>
  );
}
